"use strict";
exports.__esModule = true;
var angular = require("angular");
var ExperimentNames = {
    'Discovery': [
        'Expert Stakeholder Interview', 'Partner Supplier Interview', '404 Test', 'Feature Stub',
        '3D Model', 'Paper Prototype', 'Brochure', 'Explainer Video', 'Buy A Feature', 'Product Box'
    ],
    'Specify/Navigate': [
        'Clickable Prototype', 'Single Feature MVP', 'Concierge', 'Life Size Prototype', 'Landing Page',
        'Crowdfunding', 'PreSale', 'Wizard of OZ', 'Mock Sale', 'Letter of Intent'
    ],
    'Mitigate/Validate': [],
    'Manage': []
};
var ZONE_COLORS = {
    'DISCOVERY': '#ffcce469',
    'SPECIFY_NAVIGATE': '#ffffb3F0',
    'MITIGATE_VALIDATE': '#a0c5f899',
    'MANAGE': '#b3ffe4A0'
};
function makeIssueZoneAndColor(ignorance, impact) {
    var issueColor = ZONE_COLORS.MANAGE;
    var issueZone = 'Manage';
    if (ignorance >= 5 && impact >= 5) {
        issueColor = ZONE_COLORS.DISCOVERY;
        issueZone = 'Discovery';
    }
    else if (ignorance >= 5 && impact < 5) {
        issueColor = ZONE_COLORS.SPECIFY_NAVIGATE;
        issueZone = 'Specify/Navigate';
    }
    else if (ignorance < 5 && impact >= 5) {
        issueColor = ZONE_COLORS.MITIGATE_VALIDATE;
        issueZone = 'Mitigate/Validate';
    }
    return { 'issueZone': issueZone, 'issueColor': issueColor };
}
function formatIssueData(item) {
    var score = item.prevIG * item.prevIM;
    var issueZoneDetails = makeIssueZoneAndColor(item.prevIG, item.prevIM);
    item['prevScore'] = score;
    item['cost'] = 'cost' in item ? item.cost : undefined;
    item['duration'] = 'duration' in item ? item.duration : undefined;
    item['expName'] = 'expName' in item ? item.expName : 'Other';
    item['otherExpName'] = 'otherExpName' in item ? item.otherExpName : undefined;
    item['issueZone'] = issueZoneDetails['issueZone'];
    item['done'] = isFilled(item);
    item['includeInSprint'] = 'includeInSprint' in item ? item.includeInSprint : true;
    item['issueColor'] = issueZoneDetails['issueColor'];
    item['issueDescription'] = 'issueDescription' in item ? item.issueDescription : undefined;
    item['needToLearn'] = 'needToLearn' in item ? item.needToLearn : undefined;
    item['goingToLearn'] = 'goingToLearn' in item ? item.goingToLearn : undefined;
    item['toMeasure'] = 'toMeasure' in item ? item.toMeasure : undefined;
    item['successCriteria'] = 'successCriteria' in item ? item.successCriteria : undefined;
    item['issueFactor'] = 'issueFactor' in item ? item.issueFactor : undefined;
    item['inIterationPlan'] = 'inIterationPlan' in item ? item.inIterationPlan : false;
    item['startDate'] = 'startDate' in item ? new Date(item.startDate) : undefined;
    item['type'] = 'type' in item ? item.type : 'default';
    return item;
}
function isFilled(item) {
    return item.needToLearn && item.needToLearn !== "" &&
        item.goingToLearn && item.goingToLearn !== "" &&
        item.toMeasure && item.toMeasure !== "" &&
        item.successCriteria && item.successCriteria !== "" &&
        item.otherExpName && item.otherExpName !== "" &&
        item.cost && item.cost !== "" &&
        item.duration && item.duration !== "";
}
var ExperimentManagementComponent = /** @class */ (function () {
    function ExperimentManagementComponent($rootScope, $scope, $timeout) {
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.$timeout = $timeout;
        ctrl.$rootScope = $rootScope;
        ctrl.dashboardExpPriority = false;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        ctrl.showGenerateBtn = false;
        ctrl.guideCommand = '';
        $scope.$on('command:EXPERIMENT_MANAGEMENT', function (event, args) {
            ctrl.guideCommand = '';
            ctrl.initComponent(event, args);
            $scope.$emit('workbench:loading', { 'load': false });
        });
        $timeout();
        $('select option')
            .filter(function () {
            return !this.value || $.trim(this.value).length == 0 || $.trim(this.text).length == 0;
        })
            .remove();
    }
    // checkTitle() {
    //     let ctrl = this;
    //     if (ctrl.title == 'Experiment Priority') {
    //         ctrl.generateGraph();
    //         return true;
    //     }
    //     return false;
    // }
    ExperimentManagementComponent.prototype.setGlobalDirty = function () {
        var ctrl = this;
        ctrl.$timeout(function () {
            ctrl.$rootScope.smartorgDirty = ctrl.isDirty;
        }, 0);
    };
    ExperimentManagementComponent.prototype.getLearningPlanData = function () {
        var ctrl = this;
        ctrl.smartorg.getInavLearningPlanData(ctrl.node['_id']).then(function (data) {
            ctrl.planDescription = data['description'];
            ctrl.planResult = data['result'];
            ctrl.planRecommendation = data['recommendation'];
            ctrl.actionMilestoneCheckpoint = new Date(data['actionMilestoneCheckpoint']);
            ctrl.actionBudget = data['actionBudget'];
            ctrl.$scope.$apply();
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', 'Cannot get Learning Plan data' + err.message);
        });
    };
    ExperimentManagementComponent.prototype.calcDurationAndMilestoneCheckpoint = function () {
        var ctrl = this;
        ctrl.budget = 0;
        ctrl.learningPlanData = [];
        ctrl.issueData.forEach(function (issue) {
            if (issue.inIterationPlan) {
                ctrl.budget += issue.cost;
                issue.endDate = issue.startDate ? new Date(issue.startDate.getTime() + (issue.duration * 7 * 24 * 60 * 60 * 1000)) : undefined;
                ctrl.learningPlanData.push(issue);
            }
        });
        //let descSortByStartDate = angular.copy(ctrl.learningPlanData).sort((a, b) => b.startDate - a.startDate);
        var ascSortByStartDate = angular.copy(ctrl.learningPlanData).sort(function (a, b) { return a.startDate - b.startDate; });
        var descSortByEndDate = angular.copy(ctrl.learningPlanData).sort(function (a, b) { return b.endDate - a.endDate; });
        ctrl.milestoneCheckpoint = descSortByEndDate[0].endDate ? descSortByEndDate[0].endDate.toLocaleString().split(',')[0] : '-';
        var diffInTime = descSortByEndDate[0].endDate - ascSortByStartDate[0].startDate;
        ctrl.durationInWeeks = (diffInTime / (1000 * 3600 * 24 * 7)).toFixed(1);
    };
    ExperimentManagementComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = "Experiment Management";
        ctrl.nodeName = args.node.name;
        ctrl.tornadoFactors = args.factors;
        ctrl.tornadoFactors.forEach(function (f) {
            f['Comment'] = decodeURIComponent(f['Comment']);
        });
        ctrl.tornadoFactors = ctrl.tornadoFactors.concat([
            { 'Factor': 'Chance of Failure - High (75% to 100%)', 'Comment': '' },
            { 'Factor': 'Chance of Failure - Middle (Around 50%)', 'Comment': '' },
            { 'Factor': 'Chance of Failure - Low (Less than 25%)', 'Comment': '' }
        ]);
        ctrl.origTornadoFactors = angular.copy(ctrl.tornadoFactors);
        ctrl.node = args.node;
        ctrl.issueData = [];
        ctrl.selectedIssue = null;
        ctrl.isDirty = false;
        ctrl.getIssueDetailsFromDb();
        ctrl.experimentNames = ExperimentNames;
        ctrl.menu = [];
        ctrl.setGlobalDirty();
    };
    ExperimentManagementComponent.prototype.selectFactor = function () {
        var ctrl = this;
        ctrl.currExperiment.issueFactor = ctrl.selectedFactor;
        ctrl.checkSave();
    };
    ExperimentManagementComponent.prototype.getIssueDetailsFromDb = function () {
        var ctrl = this;
        ctrl.smartorg.getInavIssueData(ctrl.node['_id']).then(function (res) {
            if (res.status == 1) {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
            else {
                res.sort(function (a, b) { return (a.prevScore < b.prevScore) ? 1 : ((b.prevScore < a.prevScore) ? -1 : 0); });
                ctrl.issueData = res.map(function (item) { return formatIssueData(item); });
                ctrl.showGenerateBtn = true;
                ctrl.menu = [];
                ctrl.$scope.$apply();
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    ExperimentManagementComponent.prototype.initSelectFactors = function () {
        var ctrl = this;
        if (ctrl.currExperiment.issueFactor) {
            var selectedFactorIndex = ctrl.origTornadoFactors.findIndex(function (f) { return (ctrl.currExperiment.issueFactor.Factor === f.Factor); });
            ctrl.selectedFactor = ctrl.origTornadoFactors[selectedFactorIndex];
        }
        else {
            ctrl.selectedFactor = undefined;
        }
    };
    ExperimentManagementComponent.prototype.selectIssue = function (index) {
        var ctrl = this;
        ctrl.selectedIndex = index;
        ctrl.selectedIssue = ctrl.issueData[index];
        $("#experimentInput").focus();
        ctrl.currExperiment = formatIssueData(ctrl.selectedIssue);
        // ctrl.currExperiment = {
        //     expName: 'expName' in ctrl.selectedIssue ? ctrl.selectedIssue.expName : 'Other',
        //     cost: 'cost' in ctrl.selectedIssue ? ctrl.selectedIssue.cost : undefined,
        //     duration: 'duration' in ctrl.selectedIssue ? ctrl.selectedIssue.duration : undefined,
        //     newIG: 'newIG' in ctrl.selectedIssue ? ctrl.selectedIssue.newIG : undefined,
        //     newIM: 'newIM' in ctrl.selectedIssue ? ctrl.selectedIssue.newIM : undefined,
        //     prevIG: ctrl.selectedIssue.prevIG,
        //     prevIM: ctrl.selectedIssue.prevIM,
        //     includeInSprint: ctrl.selectedIssue.includeInSprint,
        //     otherExpName: 'otherExpName' in ctrl.selectedIssue ? ctrl.selectedIssue.otherExpName : undefined,
        //     issueFactor: 'issueFactor' in ctrl.selectedIssue ? ctrl.selectedIssue.issueFactor : undefined,
        //     issueDescription: 'issueDescription' in ctrl.selectedIssue ? ctrl.selectedIssue.issueDescription : undefined,
        //     needToLearn: 'needToLearn' in ctrl.selectedIssue ? ctrl.selectedIssue.needToLearn : undefined,
        //     goingToLearn: 'goingToLearn' in ctrl.selectedIssue ? ctrl.selectedIssue.goingToLearn : undefined,
        //     toMeasure: 'toMeasure' in ctrl.selectedIssue ? ctrl.selectedIssue.toMeasure : undefined,
        //     successCriteria: 'successCriteria' in ctrl.selectedIssue ? ctrl.selectedIssue.successCriteria : undefined
        // };
        if (ctrl.experimentNames[ctrl.selectedIssue.issueZone].length == 0) {
            ctrl.expSelected = true;
        }
        else {
            if (ctrl.experimentNames[ctrl.selectedIssue.issueZone].indexOf(ctrl.selectedIssue.expName) == -1) {
                ctrl.currExperiment['expName'] = 'Other';
            }
            else {
                ctrl.currExperiment['expName'] = ctrl.selectedIssue.expName;
            }
        }
        ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
        ctrl.initSelectFactors();
        ctrl.expSelected = true;
    };
    ExperimentManagementComponent.prototype.updateCurrExp = function () {
        var ctrl = this;
        ctrl.expSelected = true;
        ctrl.checkSave();
    };
    ExperimentManagementComponent.prototype.updateIssueData = function () {
        var ctrl = this;
        var updatedIssueData = angular.copy(ctrl.issueData);
        updatedIssueData[ctrl.selectedIndex] = ctrl.currExperiment;
        // updatedIssueData[ctrl.selectedIndex]['expName'] = ctrl.currExperiment['expName'];
        // updatedIssueData[ctrl.selectedIndex]['otherExpName'] = ctrl.currExperiment['otherExpName'];
        // updatedIssueData[ctrl.selectedIndex]['cost'] = ctrl.currExperiment['cost'];
        // updatedIssueData[ctrl.selectedIndex]['duration'] = ctrl.currExperiment['duration'];
        // updatedIssueData[ctrl.selectedIndex]['newIG'] = ctrl.currExperiment['newIG'];
        // updatedIssueData[ctrl.selectedIndex]['newIM'] = ctrl.currExperiment['newIM'];
        // if (ctrl.currExperiment['newIG'] && ctrl.currExperiment['newIM']) {
        //     updatedIssueData[ctrl.selectedIndex]['newScore'] = ctrl.currExperiment['newIM'] * ctrl.currExperiment['newIG'];
        //     updatedIssueData[ctrl.selectedIndex]['deltaScore'] = updatedIssueData[ctrl.selectedIndex]['prevScore'] - updatedIssueData[ctrl.selectedIndex]['newScore'];
        // }
        // updatedIssueData[ctrl.selectedIndex]['includeInSprint'] = ctrl.currExperiment['includeInSprint'];
        // updatedIssueData[ctrl.selectedIndex]['issueFactor'] = ctrl.currExperiment['issueFactor'];
        // updatedIssueData[ctrl.selectedIndex]['issueDescription'] = ctrl.currExperiment['issueDescription'];
        // updatedIssueData[ctrl.selectedIndex]['needToLearn'] = ctrl.currExperiment['needToLearn'];
        // updatedIssueData[ctrl.selectedIndex]['goingToLearn'] = ctrl.currExperiment['goingToLearn'];
        // updatedIssueData[ctrl.selectedIndex]['toMeasure'] = ctrl.currExperiment['toMeasure'];
        // updatedIssueData[ctrl.selectedIndex]['successCriteria'] = ctrl.currExperiment['successCriteria'];
        return updatedIssueData;
    };
    ExperimentManagementComponent.prototype.disableExpName = function () {
        var ctrl = this;
        for (var i = 0; i < ctrl.experimentNames[ctrl.selectedIssue.issueZone].length; i++) {
            if (ctrl.currExperiment.expName == ctrl.experimentNames[ctrl.selectedIssue.issueZone][i]) {
                return true;
            }
        }
        return false;
    };
    ExperimentManagementComponent.prototype.updateIterPlanInIssueData = function () {
        var ctrl = this;
        var updatedIssueData = angular.copy(ctrl.issueData);
    };
    ExperimentManagementComponent.prototype.saveCurrentExp = function () {
        var ctrl = this;
        ctrl.updatedIssueData = ctrl.updateIssueData();
        ctrl.issueData = angular.copy(ctrl.updatedIssueData);
        ctrl.saveIssueData();
    };
    ExperimentManagementComponent.prototype.saveIssueData = function (updateDurationAndMilestone) {
        if (updateDurationAndMilestone === void 0) { updateDurationAndMilestone = false; }
        var ctrl = this;
        ctrl.smartorg.saveInavIssueDataFromExpMgmt(ctrl.issueData[ctrl.selectedIndex], ctrl.node['_id']).then(function (res) {
            if (res) {
                ctrl.issueData[ctrl.selectedIndex] = formatIssueData(ctrl.issueData[ctrl.selectedIndex]);
                ctrl.isDirty = false;
                ctrl.setGlobalDirty();
                ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
                ctrl.showAlert('success', 'Saved!', 'Details saved for issue "' +
                    ctrl.issueData[ctrl.selectedIndex]['name'] + '"');
                if (updateDurationAndMilestone) {
                    ctrl.calcDurationAndMilestoneCheckpoint();
                }
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    ExperimentManagementComponent.prototype.checkSave = function () {
        var ctrl = this;
        ctrl.isDirty = false;
        var keys = Object.keys(ctrl.currExperiment);
        for (var i = 0; i < keys.length; i++) {
            if (keys[i] == 'issueFactor') {
                if (ctrl.currExperiment[keys[i]]['Factor'] !== ctrl.origCurrExperiment[keys[i]]['Factor']) {
                    ctrl.isDirty = true;
                    break;
                }
            }
            else if (ctrl.currExperiment[keys[i]] !== ctrl.origCurrExperiment[keys[i]]) {
                ctrl.isDirty = true;
                break;
            }
        }
        ctrl.setGlobalDirty();
    };
    ExperimentManagementComponent.prototype.changeStartDate = function (startDate, issueName) {
        var ctrl = this;
        ctrl.issueData.forEach(function (issue, idx) {
            if (issue.name == issueName) {
                ctrl.selectedIndex = idx;
                issue.startDate = startDate.toString();
                ctrl.saveIssueData(true);
            }
        });
    };
    ExperimentManagementComponent.prototype.saveLearningPlanData = function () {
        var ctrl = this;
        ctrl.smartorg.saveInavLearningPlanData(ctrl.node['_id'], ctrl.planDescription, ctrl.planResult, ctrl.planRecommendation, ctrl.actionMilestoneCheckpoint.toString(), ctrl.actionBudget).then(function (res) {
            if (res) {
                ctrl.showAlert('success', 'Success!', 'Details are saved.');
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    ExperimentManagementComponent.prototype.milestoneVariance = function () {
        var ctrl = this;
        if (ctrl.milestoneCheckpoint && ctrl.actionMilestoneCheckpoint) {
            var diffInTime = angular.copy(new Date(ctrl.milestoneCheckpoint)) - ctrl.actionMilestoneCheckpoint;
            return (diffInTime / (1000 * 3600 * 24 * 7)).toFixed(1) + ' weeks';
        }
        return 'NA';
    };
    return ExperimentManagementComponent;
}());
angular.module('smartorg.r6.acts.experimentManagement', []).component('experimentManagement', {
    template: require('./experiment-management.component.html'),
    controller: ExperimentManagementComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = 'smartorg.r6.acts.experimentManagement';
//# sourceMappingURL=experiment-management.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/experiment-management/experiment-management.component.js